import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { LogQueryDetails } from "./components/LogQueryDetails";

export function LogQueryPage() {
  return (
    <LqsPage title="Query Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogQueryDetails />
      </Container>
    </LqsPage>
  );
}
